import { render } from "./CateList.vue?vue&type=template&id=8ef4e36e"
import script from "./CateList.vue?vue&type=script&lang=js"
export * from "./CateList.vue?vue&type=script&lang=js"

import "./CateList.vue?vue&type=style&index=0&id=8ef4e36e&lang=scss"
import "./CateList.vue?vue&type=style&index=1&id=8ef4e36e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__